// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { BootstrapButton, BootstrapImage, BootstrapLink } from '../../dsl/front';
import { AbstractModuleUi } from '../_abstract/ui';
import { ModuleHeaderUi } from '../_components/ui';
import { prepareImage } from '../_filters';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let LogosModuleUi = class LogosModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        this.resolvedLogos = [];
    }
    /**
     * @inheritDoc
     */
    async fetchRelated() {
        const logosToResolve = this.module.content.logos || [];
        try {
            await Promise.all(logosToResolve.map(logo => {
                return new Promise((resolve, reject) => {
                    this.relatedService.resolve(logo.image, {})
                        .then(resolvedImage => {
                        this.resolvedLogos = [...this.resolvedLogos, {
                                url: logo.url,
                                image: prepareImage(resolvedImage, this.imageRatio, 100, this.module.isLazyLoaded)
                            }];
                        resolve();
                    })
                        .catch(e => {
                        if (this.debug)
                            console.warn(e);
                        reject(e);
                    });
                });
            }));
        }
        catch (e) {
            this.onError(e);
        }
        this.resolvedLogos.length > 0 ? this.onReady() : this.onError();
    }
};
LogosModuleUi = __decorate([
    Component({
        name: 'LogosModuleUi',
        components: { BootstrapButton, BootstrapImage, BootstrapLink, ModuleHeaderUi },
        async created() {
            await this.fetchRelated();
        },
        template: `
    <section class="logos-module" :style="{ background }">
      <div class="container">
        <div class="row">
          <div class="col">

            <!-- Header -->
            <ModuleHeaderUi v-if="module.content.header" :header="module.content.header" />

            <!-- Logotypes list -->
            <ul v-if="resolvedLogos && resolvedLogos.length" class="logos-module__list list-unstyled">
              <li v-for="logo in resolvedLogos" :key="logo.url">
                <BootstrapLink :link="{ target: logo.url, isExternal: true }" class="logos-module__list__item">
                  <BootstrapImage v-bind="logo.image" class="logos-module__list__item__logo" />
                </BootstrapLink>
              </li>
            </ul>
            <!-- END | Logotypes list -->

          </div>
        </div>
      </div>
    </section>
  `
    })
], LogosModuleUi);
export { LogosModuleUi };
